import styled, { css } from 'styled-components';

import { COLOR_GRAY_30 } from 'styles/variables/colors';
import glow from 'styles/animations/glow';

export const Container = styled.section`
  margin-bottom: 34px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
`;

export const ShowMore = styled.button`
  background: none;
  border: 0;
  color: #5f29cc;
  font-size: 16px;
  padding: 0;
  margin-top: 20px;
  display: flex;
  align-items: stretch;

  &:hover {
    text-decoration: underline;
  }
`;

export const Title = styled.button`
  margin: 15px 0 4px 0;
  font-weight: bold;
  font-size: 1rem;
  cursor: pointer;
  display: inline-block;
  padding: 0;
  background: transparent;
  border: 0;

  &:hover {
    text-decoration: underline;
  }

  ${(props) =>
    !props.onClick &&
    css`
      &:hover {
        text-decoration: none;
      }

      cursor: initial;
    `}
`;

export const InnerContainer = styled.div`
  display: flex;
  overflow-y: hidden;
  overflow-x: scroll;
  padding-bottom: 75px;

  @media (min-width: 769px) {
    overflow: initial;
    flex-wrap: wrap;
    margin-bottom: -3px;
    padding-bottom: 10px;
  }

  & > div,
  & > button,
  & > a {
    margin: 0 24px 0 0;

    &:last-of-type {
      margin-right: 0;
    }

    @media (min-width: 769px) {
      margin-bottom: 30px;
    }
  }
`;

export const LoaderTitle = styled.div`
  animation: ${glow} 1.5s linear infinite;
  background: ${COLOR_GRAY_30};
  height: 20px;
  width: 100px;
  margin-bottom: 15px;
`;
